import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { EvRepositoryApi } from "../../apiclient/api/EvRepositoryApi";
var repositoryApi = new EvRepositoryApi();
export var fetchFolders = createAsyncThunk("folders/get", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(userSession) {
    var _userSession$user;
    var response, ids, count, entities;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if ((userSession === null || userSession === void 0 ? void 0 : (_userSession$user = userSession.user) === null || _userSession$user === void 0 ? void 0 : _userSession$user.userAnonymity) === "INDIVIDUAL") {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", {
              count: 0,
              entities: {},
              ids: []
            });
          case 2:
            _context.next = 4;
            return repositoryApi.getCollectionResource("folders", {
              size: "100",
              sort: "folderName"
            });
          case 4:
            response = _context.sent;
            ids = [];
            count = response.page.totalElements;
            entities = {};
            response._embedded.folders.forEach(function (element) {
              ids.push(element.folderId);
              entities[element.folderId] = element;
            });
            return _context.abrupt("return", {
              count: count,
              ids: ids,
              entities: entities
            });
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export var removeFolder = createAsyncThunk("folders/remove", /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, thunkApi) {
    var folder, _response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            folder = thunkApi.getState().folders.entities[id];
            if (!folder) {
              _context2.next = 8;
              break;
            }
            _context2.next = 4;
            return repositoryApi.deleteItemResource("folders", id);
          case 4:
            _response = _context2.sent;
            return _context2.abrupt("return", {
              count: 1,
              id: docid
            });
          case 8:
            return _context2.abrupt("return", {
              count: 0,
              message: "Unable to remove folder with id of " + id
            });
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}());
export var addFolder = createAsyncThunk("folders/add", /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(attrs, thunkApi) {
    var _response2;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(thunkApi.getState().folders.count < 10)) {
              _context3.next = 7;
              break;
            }
            _context3.next = 3;
            return repositoryApi.postCollectionResource(attrs, "folders");
          case 3:
            _response2 = _context3.sent;
            return _context3.abrupt("return", {
              count: 1,
              id: _response2.folderId,
              entity: _response2
            });
          case 7:
            return _context3.abrupt("return", {
              count: 0,
              message: "The maximum number of folders is 10.  Please save this record to another folder."
            });
          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function (_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}());
export var addFolderRecord = createAsyncThunk("folders/addwithrec", /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(attrs, thunkApi) {
    var _newFolder, _holdFolderId, _newRecord, _recordArray;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(thunkApi.getState().folders.count < 10)) {
              _context4.next = 15;
              break;
            }
            _context4.next = 3;
            return repositoryApi.postCollectionResource({
              folderName: attrs.folderName
            }, "folders");
          case 3:
            _newFolder = _context4.sent;
            //grab the folder info
            _holdFolderId = _newFolder._links.self.href.replace(/.*\//, "");
            _context4.next = 7;
            return repositoryApi.postCollectionResource({
              folderId: _holdFolderId,
              guid: attrs.docId
            }, "savedRecords");
          case 7:
            _newRecord = _context4.sent;
            //set the array to the new record
            _recordArray = [];
            _recordArray.push(_newRecord);
            _newFolder.savedRecords = _recordArray;
            _newFolder.folderId = _holdFolderId;
            return _context4.abrupt("return", {
              count: 1,
              id: _holdFolderId,
              entity: _newFolder
            });
          case 15:
            return _context4.abrupt("return", {
              count: 0,
              message: "The maximum number of folders is 10.  Please save this record to another folder."
            });
          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function (_x6, _x7) {
    return _ref4.apply(this, arguments);
  };
}());
export var addRecord = createAsyncThunk("folders/addrec", /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(attrs, thunkApi) {
    var newFolder, holdFolder, _newRecord2, _holdSavedRecords, _holdMessage;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            newFolder = thunkApi.getState().folders.entities[attrs.folderId];
            holdFolder = null; //prevent further execution if folder contains 100 records
            if (!(newFolder && newFolder.savedRecords.length < 100)) {
              _context5.next = 12;
              break;
            }
            // TODO: add adsitional attr values as needed. Example, date values may need to be generated from the current time
            _newRecord2 = null;
            _context5.next = 6;
            return repositoryApi.postCollectionResource({
              folderId: newFolder.folderId,
              guid: attrs.docId
            }, "savedRecords");
          case 6:
            _newRecord2 = _context5.sent;
            //must create a copy in redux instead of modifying original directly
            holdFolder = Object.assign({}, newFolder);
            if (_newRecord2) {
              _holdSavedRecords = [];
              newFolder.savedRecords.forEach(function (record) {
                _holdSavedRecords.push(record);
              });
              _holdSavedRecords.push(_newRecord2);
              holdFolder.savedRecords = _holdSavedRecords;
            }
            return _context5.abrupt("return", {
              count: 1,
              id: holdFolder.folderId,
              entity: holdFolder
            });
          case 12:
            _holdMessage = "";
            if (!newFolder) {
              _holdMessage = "Unable to find folder with folder id of " + attrs.folderId + ".";
            } else {
              _holdMessage = "The maximum number of records per folder is 100.  Please save this record to another folder.";
            }
            return _context5.abrupt("return", {
              count: 0,
              message: _holdMessage
            });
          case 15:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function (_x8, _x9) {
    return _ref5.apply(this, arguments);
  };
}());
var initialState = {
  status: "init",
  count: 0,
  entities: {},
  ids: []
};
var foldersSlice = createSlice({
  name: "folders",
  initialState: initialState,
  reducers: {
    // omit reducer cases
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchFolders.pending, function (state) {
      state.status = "pending";
    }).addCase(fetchFolders.fulfilled, function (state, _ref6) {
      var payload = _ref6.payload;
      state.status = "done";
      state.count = payload.count;
      state.ids = payload.ids;
      state.entities = payload.entities;
    }).addCase(fetchFolders.rejected, function (state) {
      state.status = "error";
    }).addCase(removeFolder.pending, function (state) {
      state.status = "pending";
    }).addCase(removeFolder.fulfilled, function (state, _ref7) {
      var payload = _ref7.payload;
      state.status = "done";
      if (payload.count === 1) {
        var _pos = state.ids.indexOf(payload.id);
        if (_pos > -1) {
          delete state.entities[payload.id];
          state.count -= 1;
          state.ids = state.ids.filter(function (id) {
            return id in state.entities;
          });
        }
      }
    }).addCase(removeFolder.rejected, function (state) {
      state.status = "error";
    }).addCase(addFolder.pending, function (state) {
      state.status = "pending";
    }).addCase(addFolder.fulfilled, function (state, _ref8) {
      var payload = _ref8.payload;
      state.status = "done";
      state.count += 1;
      state.ids.push(payload.id);
      state.entities[payload.id] = payload.entity;
    }).addCase(addFolder.rejected, function (state) {
      state.status = "error";
    }).addCase(addFolderRecord.pending, function (state) {
      state.status = "pending";
    }).addCase(addFolderRecord.fulfilled, function (state, _ref9) {
      var payload = _ref9.payload;
      state.status = "done";
      state.count += 1;
      state.ids.push(payload.id);
      state.entities[payload.id] = payload.entity;
    }).addCase(addFolderRecord.rejected, function (state) {
      state.status = "error";
    }).addCase(addRecord.pending, function (state) {
      state.status = "pending";
    }).addCase(addRecord.fulfilled, function (state, _ref10) {
      var payload = _ref10.payload;
      state.status = "done";
      if (payload.count === 1) {
        state.entities[payload.id] = payload.entity;
      }
    }).addCase(addRecord.rejected, function (state) {
      state.status = "error";
    });
  }
});
export var selectFoldersStatus = function selectFoldersStatus(state) {
  return state.folders.status;
};
export var selectFoldersCount = function selectFoldersCount(state) {
  return state.folders.count;
};
export var selectFoldersState = function selectFoldersState(state) {
  return state.folders;
};
export default foldersSlice.reducer;